import { render, staticRenderFns } from "./SkillIconCanvasComponent.vue?vue&type=template&id=287bff17&"
import script from "./SkillIconCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./SkillIconCanvasComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SkillIconCanvasComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports